export const PLAYBACK_RATE_OPTIONS = [
  { label: "0.75x", value: 0.75 },
  { label: "0.8x", value: 0.8 },
  { label: "0.9x", value: 0.9 },
  { label: "1.0x", value: 1.0 },
] as const
